__webpack_require__.p = "https://demo.algovicrm.com/";